import React from 'react';
import { connect } from 'react-redux';
import WixBaseUI from '@wix/wix-base-ui';
import { useTranslation } from 'react-i18next';
import { EMPTY_ACCOUNT_HEIGHT } from '../../../constants';
import triggerEvent from '../../../actions/services/biSiteLogger';
import triggerEventEditor from '../../../actions/services/biEditorLogger';
import biData from '../../../bi/errorEvents.json';
import biDataEditor from '../../../bi/editorEvents.json';
// actions
import { getInfoByError } from '../../../actions/more/manageErrors';
// Style
import { st, classes } from './emptyState.st.css';

const MockIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    className={st(classes.icon)}
    viewBox="0 0 16 16"
  >
    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
    <path d="M8.93 6.588l-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z" />
  </svg>
);
const EmptyState = ({ error, viewMode, isEmptyAccount }) => {
  const { t } = useTranslation();
  const { RichText, Composites, Illustration } = WixBaseUI;
  const data = getInfoByError(error, isEmptyAccount);
  if (viewMode !== 'editor') {
    triggerEvent({ ...biData.EMPTY_STATE, description: t(data.titleKey) });
    return <div className={st(classes.rootLiveSite)}></div>;
  }
  triggerEventEditor({
    ...biDataEditor.VIEW_ERROR_ON_WIDGET,
    description: t(data.titleKey),
  });
  return (
    <div style={isEmptyAccount ? { height: `${EMPTY_ACCOUNT_HEIGHT}px` } : {}}>
      <Composites.RichTextWithIllustrationVertical>
        <Illustration>
          <MockIcon />
        </Illustration>
        <Composites.RichText>
          <RichText className={st(classes.icon)} type="T19">
            {t(data.titleKey)}
          </RichText>
          <RichText className={st(classes.icon)}>
            {t(data.subTitleKey)}
          </RichText>
        </Composites.RichText>
      </Composites.RichTextWithIllustrationVertical>
    </div>
  );
};
const mapStateToProps = (state) => ({
  viewMode: state.appReducer.viewMode,
});
export default connect(mapStateToProps, null)(EmptyState);
